export const getActivateAccountMenuData = [
  {
    category: true,
    title: 'Account Setup',
  },
  {
    title: 'Activate Account',
    key: 'activateAccount',
    icon: 'fe fe-briefcase',
    url: '/activate-account',
  },
  // {
  //   title: 'Dashboard',
  //   key: 'dashboard',
  //   icon: 'fe fe-home',
  //   url: '/dashboard/alpha',
  // },
]

export const getCCLeftMenuData = [
  {
    category: true,
    title: 'Currency Accounts',
  },
  {
    title: 'Balances',
    key: 'balances',
    url: '/account-balances',
    icon: 'icmn icmn-credit-card',
  },
  {
    title: 'New Payment',
    key: 'newDigitalPayment',
    url: '/new-payment',
    icon: 'fa fa-exchange',
  },
  {
    category: true,
    title: 'Settings',
  },
  {
    title: 'Profile',
    key: 'profile',
    url: '/user-profile',
    icon: 'lnr lnr-user',
  },
]

export const getRCLeftMenuData = [
  {
    category: true,
    title: 'Manage Deposits',
  },
  {
    title: 'Trades',
    key: 'trades',
    url: '/trades',
    icon: 'icmn icmn-credit-card',
  },
  {
    title: 'Report',
    key: 'reports',
    url: '/reports',
    icon: 'icmn icmn-stats-bars',
  },
]

export default { getRCLeftMenuData, getCCLeftMenuData, getActivateAccountMenuData }
